<template>
  <div class="purchase-information mt-5 lg:mt-10">
    <the-section :title="$t('ec-line005.purchaseInformation.title')">
      <div class="el-form el-form--label-top">
        <card-item
          v-if="!corporateFlag && businessAccountUseFlag"
          :label="$t('common.label.accountType')"
          :value="accountType"
        ></card-item>
        <card-item
          v-if="corporateFlag"
          :label="$t('common.memberInformation.companyName')"
          :value="data.company_name"
        ></card-item>
        <card-item :label="formLabelName" :value="Utils.helper.fullName(data.name01, data.name02)"></card-item>
        <card-item
          v-if="data.kana01"
          :label="formLabelNameKana"
          :value="Utils.helper.fullName(data.kana01, data.kana02)"
        ></card-item>
        <card-item
          v-if="data.year && data.month && data.day"
          :label="$t('common.memberInformation.birthday')"
          :value="data.year + '/' + data.month + '/' + data.day"
        ></card-item>
        <card-item v-if="data.gender" :label="$t('common.memberInformation.gender')" :value="data.gender"></card-item>
        <card-item :label="$t('common.memberInformation.email')" :value="data.email"></card-item>
        <card-item :label="$t('common.memberInformation.address')">
          <div class="text-address">
            <p class="text-gray-950 text-base lg:text-lg break-all">
              {{ Utils.helper.postalCode(data.postal_code01, data.postal_code02) }}
            </p>
            <p class="text-gray-950 text-base lg:text-lg break-all">
              {{ Utils.helper.address(data.prefecture, data.addr01, data.addr02, '') }}
            </p>
            <p class="text-gray-950 text-base lg:text-lg break-all">
              {{ data.addr03 }}
            </p>
          </div>
        </card-item>
        <card-item :label="$t('common.memberInformation.phoneNumber')" :value="data.phone_number"></card-item>
      </div>
    </the-section>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import CardItem from './CardInfoItem.vue'

export default {
  components: { TheSection, CardItem },
  props: {
    data: { type: Object, default: () => {} },
  },
  computed: {
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    formLabelName() {
      return this.corporateFlag || !this.data.business_account_flag
        ? this.$t('common.memberInformation.fullName')
        : this.$t('common.memberInformation.companyName')
    },
    formLabelNameKana() {
      return this.corporateFlag || !this.data.business_account_flag
        ? this.$t('common.memberInformation.nameKana')
        : this.$t('common.memberInformation.companyNameKana')
    },
    accountType() {
      return this.data.business_account_flag ? this.$t('common.label.business') : this.$t('common.label.personal')
    },
    businessAccountUseFlag() {
      return this.$store.getters['auth/shop']?.business_account_use_flag
    },
  },
}
</script>
